export const REQUEST_REGION_LINK =
  'https://www.influxdata.com/influxdb-cloud-2-0-provider-region/'
